import { Odata, Utils } from "@mitel/cloudlink-sdk";
import { gwpOnboardingPbxTags, productCodes } from "../constants/constants";

export class Util {
    public static getParameterFromNextLink(name: string, link: string) {
        const match = new RegExp(`\\$?${name}=([^&]+)&?`).exec(link);
            if (!match) {
                return undefined;
            } else {
                return match[1];
            }
    }

	public static getAllNextParamsFromCollection(response) {
		if (!response || !response._links || !response._links.next) {
            return undefined;
        }
        else {
            let allParams = Utils.getOdataNext(response);
			allParams['$SearchKeys'] = this.getParameterFromNextLink('searchKeys', response._links.next);
			allParams['items'] = this.getParameterFromNextLink('items', response._links.next);
			allParams['itemKeys'] = this.getParameterFromNextLink('itemKeys', response._links.next);
			return allParams;
        }
	}

	public static addQueryParamsToUrl(url: string, odata: Odata): string {
		if (!odata) {
			return url;
		}
		let _url = new URL(url)
		Object.entries(odata).forEach(([key, value]) => {
			if (!!value) {
				// format the case of Odata $Filter, $SkipToken, etc. to be lowercase -> $filter, $skipToken
				if (key.startsWith('$')) {
					key = '$' + key[1].toLowerCase() + key.slice(2);
				}
				_url.searchParams.set(key, value);
			}
		});
		return _url.toString();
	}

    // this timeout can be awaited
    public static timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // examples of what need to be generated
	//https://authentication.{region}.{cloud}.api.mitel.io/2017-09-01/saml2/{accountId}
	//https://authentication.us.dev.api.mitel.io/2017-09-01/saml2/d3e9b65c-53cb-4b47-a780-7dfc0816199b
	//https://authentication.eu.api.mitel.io/2017-09-01/saml2/d3e9b65c-53cb-4b47-a780-7dfc0816199b

	public static generateSsoValuesFor3rdParty(claims: any, accountId: string): any
	{
		let values: any = {
			entityId: '',
			replyUrl: ''
		}
		if (claims && claims.iss) {
            const iss = claims.iss;
            const urlParts = iss.split('/');
			const cloudParts = urlParts[2].split('.');
			let cloudRegion = '';
			for ( var i = 2; i < cloudParts.length; i++ )
			{
				cloudRegion += "." + cloudParts[i];
			}
			values.entityId = "https://authentication" + cloudRegion + "/2017-09-01/saml2/" + accountId
			values.replyUrl = values.entityId + "/cs";
		}
		return values;
	}

	public static isReadOnlyMode(source: string){
		if(['GALAXY', 'GOOGLE', 'FACEBOOK', 'UNKNOWN SOURCE TYPE'].indexOf(source) !== -1)
			return true;
		else
			return false;
	}

	/*
	 taken from progressMap in GWP code (note some are no longer used)
        {'step': 0, 'name': 'new', 'status': stepStatus.FINISH_BUILD_CUSTOMER},
        {'step': 1, 'name': 'account', 'status': stepStatus.CONFIG_GATEWAY},
        {'step': 2, 'name': 'site', 'status': stepStatus.ADD_PBX},
        {'step': 3, 'name': 'pbx', 'status': stepStatus.CONNECT_PBX},
        {'step': 4, 'name': 'connect', 'status': stepStatus.CONFIG_OFFICELINK},
        {'step': 5, 'name': 'officelink', 'status': stepStatus.OVERVIEW},
        {'step': 5, 'name': 'officeconnect', 'status': stepStatus.OVERVIEW},
        {'step': 6, 'name': 'advanced', 'status': stepStatus.OVERVIEW},
        {'step': 7, 'name': 'overview', 'status': stepStatus.OVERVIEW}
	*/
	public static isGWPOnboardingPastStep(tags: any, step: string): boolean {
		if(tags && tags.products && tags.products.length > 0){
			let isPastStep = tags.products.includes('Gateway') &&
			tags["on-board-progress"] &&
			tags["on-board-progress"].step && 
			(tags["on-board-progress"].step > step || 
			(tags["on-board-progress"].step === step && tags["on-board-progress"].succeeded == true)) ? true : false;

			return isPastStep;
		}
		return false;
	}

	//Using same step logic as rest of the file.
	//Might need to be corrected as per CLSD-4099
	//'Done' means they progressed enough to have a pbx connected
	public static isOnboardingDoneInGWP(tags: any): boolean {
		if(tags && tags.products && tags.products.length > 0){
			let isOnboardingDone = tags.products.includes('Gateway') &&
			tags["on-board-progress"] &&
			tags["on-board-progress"].step && tags["on-board-progress"].step > 4 &&
			tags["on-board-progress"].succeeded == true ? true : false;

			return isOnboardingDone;
		}
		return false;
	}

	//Never should there be more than one pbx type in the tags - but in that case, all valid pbx types found in the tags will be returned
	//It's up to those who use this method to make sure the length of the returned list is either 0 or 1. 
	//A length > 1 indicates a bad state of product tags.
	public static getPbxTypesFromTags(tags: any): string[] {
		let pbxsFound = [];
		if(tags && tags.products && tags.products.length > 0){
			for(let i = 0; i< gwpOnboardingPbxTags.length; ++i ){
				if(tags.products.includes(gwpOnboardingPbxTags[i])){
					pbxsFound.push(gwpOnboardingPbxTags[i]);
				}
			}
		}
		return pbxsFound;
	}

	public static doesAccountHaveMiVoice400Onboarded( tags: any ): boolean
	{
		if (tags && tags.products &&
			tags.products.includes('MiVoice Office 400') && tags.products.includes('Gateway') &&
			tags["on-board-progress"] &&
			tags["on-board-progress"].step && tags["on-board-progress"].step > 4 &&
			tags["on-board-progress"].succeeded == true )
			return true;

		return false;
	}

	public static doesAccountHaveMiVoiceBusinessOnboarded( tags: any ): boolean
	{
		if (tags && tags.products &&
			tags.products.includes('MiVoice Business') && tags.products.includes('Gateway') &&
			tags["on-board-progress"] &&
			tags["on-board-progress"].step && tags["on-board-progress"].step > 4 &&
			tags["on-board-progress"].succeeded == true )
			return true;

		return false;
	}

	public static doesAccountHaveMiVoiceBusinessInNetworkElements( networkElements: any ): boolean
	{
		if (networkElements && networkElements.length && networkElements.length > 0){
			let mivbDetected = networkElements.find( element => (element.type && element.type === '3300 ICP'));
			if(mivbDetected){
				return true;
			}
		}

		return false;
	}

  public static doesAccountSupportMultiplePBX(networkElements: any): boolean {
    if (networkElements && networkElements.length && networkElements.length > 0) {
      let pbxs = networkElements.filter(element => { return element.type && element.type === '3300 ICP' });
      if (pbxs && pbxs.length > 0) {
        let localPBXs = pbxs.filter((pbx) => { return pbx.local === true });
        if(!localPBXs || localPBXs.length === 0){
          return true;
        }
      }
    }
    return false;
  }

  public static getMiCollabFromNetworkElements(networkElements: any): any {
    if (networkElements && networkElements.length && networkElements.length > 0) {
      return networkElements.find(element => (element.type && element.type === 'MSL Server'));
    }

    return undefined;
  }

	public static getMiCollabFromSysManagerComponentsWithAdminApi(components: any): any {
		if (components && components.length && components.length > 0) {
			return components.find(element => {
				if (element.componentType && element.componentType === 'micollab')
				{
					if ( element?._embedded?.services?._embedded?.items )
					{
						return element._embedded.services._embedded.items.find( service => (service.serviceType && service.serviceType === 'adminapi'));
					}
				}
			}); 
		}
		return undefined;
	}

	public static doesAccountHaveVoiceAssistPBXOnboarded(tags: any): boolean {
		const voiceAssistSupportedPBXList = ['MiVoice 5000', 'MiVoice Business', 'MX-ONE', 'MiVoice Office 400'];
		if (tags && tags.products &&
			tags.products.some(item => voiceAssistSupportedPBXList.indexOf(item) >= 0) &&
			tags["on-board-progress"] &&
			tags["on-board-progress"].step && tags["on-board-progress"].step > 4 &&
			tags["on-board-progress"].succeeded == true)
			return true;

		return false;
	}

	/**
	 * Check Cloudlink Account tags for successfully onboarded PBX and Gateway
	 * @param tags
	 * @param supportedPBXs eg ['MiVoice 5000', 'MiVoice Business', 'MX-ONE']
	 * @returns true if Gateway is onboarded and tag.products includes a PBX from supported list
	 */
	 public static doesAccountHavePBXandGatewayOnboarded(tags: any, supportedPBXs: string[]): boolean {

		// A short discussion of the tags content...
		// tag.on-board-progress is the onboarding of a pbx by the gateway portal. The pbx type that
		// was onboarded is in tag.products.
		 // The "Gateway" entry in the products tag, means there is an API Gateway integration.
		// Today that will be there when a PBX is onboarded. Pre integration of the GWP and the
		// accounts app, you might have only seen the onboarding tags and the pbx tag but no "Gateway" tag
		//
		// An example. So in this case:
		//     supportedPBXs['MiVoice Office 400']
		// we are checking if there is a successfully & fully (not PARTIALLY) onboarded PBX of type 400.
		// So in summary:
		// tags["on-board-progress"] &&
		//             tags["on-board-progress"].step && tags["on-board-progress"].step > 4 &&
		//             tags["on-board-progress"].succeeded == true
		// means the PBX is fully & successfully onboarded.

		if (tags && tags.products &&
			tags.products.includes('Gateway') &&
			tags.products.some(item => supportedPBXs.indexOf(item) >= 0) &&
			tags["on-board-progress"] &&
			tags["on-board-progress"].step && tags["on-board-progress"].step > 4 &&
			tags["on-board-progress"].succeeded == true)
			return true;

		return false;
	}

	/**
	 * Check Cloudlink Account tags for MiCCB installed. Optionally, check a minimum version is available.
	 * @param tags
	 * @param version
	 * @returns true if tag.products includes MiCCB and if version is specified, MiCCB version is equal to or higher than the indicated version
	 */
	public static doesAccountHaveMiCCBMinVersionX(tags: any, version?: string): boolean {
		if (tags?.products?.includes(productCodes.MiCCB)) {
			if (version) {
				return tags.MiCCBProductVersion?.localeCompare(version, undefined, { numeric: true, sensitivity: 'base' }) >= 0;
			}
			return true;
		}
		return false;
	}

	// we can never know what the format of the error is 
	// try to find the message if there is one
	public static extractMessageFromError( err: any )
	{
		if ( !err )
			return undefined;

		if ( err.body && err.body.message )
		{
			if ( err.body.message.message ) // yes an error was received like this
				return err.body.message.message
			return err.body.message;
		}
			
		if ( err.error && err.error.message )
			return err.error.message;
		if ( err && err.message )
			return err.message;

		return undefined;
	}

  static parseValueAsJson(value: string) {
    let result = '';
    try {
      result = JSON.parse(value);
    } catch (e) {
      result = value;
    }
    return result;
  }
}
